import { api } from '@/api/api-client.config.ts';
import { Pickem } from '@/@types/api.types.ts';
import { useInfiniteQuery } from '@tanstack/react-query';

interface GetPickemsProps {
  offset: number;
  limit: number;
}

const getPickems = ({
  offset,
  limit,
}: GetPickemsProps): Promise<{ pickems: Pickem[] }> =>
  api.get(`/admin/pickems`, {
    params: { offset, limit },
  });

export const useGetInfinitePickems = (options?: { limit?: number }) => {
  const { limit = 20 } = options || {};

  return useInfiniteQuery({
    queryKey: ['getPickems'],
    queryFn: ({ pageParam = 0 }) =>
      getPickems({ offset: pageParam * limit, limit }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage?.pickems?.length < limit ? undefined : allPages?.length;
    },
    initialPageParam: 0,
    select: (data) => {
      // Merge leaderboard data from each page into a single array.
      // Keep all other properties as they are on page 0.
      if (!data?.pages?.length) return [];
      const mergedPickems = data.pages.flatMap((page) => page.pickems || []);
      return mergedPickems;
    },
  });
};
